import {linkStateType, ActionType, reducerStoreType} from "./types";

const defaultState = {
    linkInfo: {
        payLink: ''
    }
}

const createLink = (state: linkStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_LINK_INFO':
            return {
                ...state,
                linkInfo: action.payload
            }
        case 'CLEAR_LINK_INFO':
            return {
                ...state,
                linkInfo: defaultState.linkInfo
            }
        default:
            return state;
    }
}

export const linkInfo = (state:reducerStoreType) => (state.createLink.linkInfo)

export default createLink